import { render } from "./businessRecords.vue?vue&type=template&id=5b57154c"
import script from "./businessRecords.vue?vue&type=script&lang=js"
export * from "./businessRecords.vue?vue&type=script&lang=js"
script.render = render

export default script